export default {
    create: {
        actuality: {
            title: 'Publier une actualité'
        },
        action: {
            button: 'Ajouter une action'
        },
        category: {
            title: 'Ajouter une catégorie de ressources'
        },
        document: {
            title: 'Ajouter une ressource'
        },
        employee: {
            button: 'Ajouter un employé',
            title: 'Ajouter ou modifier un anniversaire'
        },
        event: {
            title: 'Ajouter un évènement'
        },
        notice: {
            title: 'Créer une annonce'
        },
        sub_category: {
            title: 'Ajouter une sous-catégorie de ressources'
        }
    },
    delete: {
        actuality: {
            button: 'Oui, supprimer l\'actualité',
            message: 'Êtes-vous sûr de vouloir supprimer l\'actualité :TITLE',
            popup: 'Actualitée supprimée avec succès.',
            title: 'Supprimer une actualité'
        },
        alert: {
            button: 'Supprimer l\'alerte'
        },
        category: {
            button: 'Oui, supprimer la catégorie',
            message: 'Êtes-vous sûr de vouloir supprimer la catégorie :TITLE',
            popup: 'Catégorie supprimée avec succès.',
            title: 'Supprimer une catégorie de ressources'
        },
        document: {
            button: 'Oui, supprimer le document',
            message: 'Êtes-vous sûr de vouloir supprimer le document :TITLE',
            popup: 'Document supprimé avec succès.',
            title: 'Supprimer un document'
        },
        employee: {
            button: 'Oui, supprimer l\'employé',
            message: 'Êtes-vous sûr de vouloir supprimer l\'employé :TITLE',
            popup: 'Employé supprimé avec succès.',
            title: 'Supprimer un employé'
        },
        event: {
            button: 'Oui, supprimer l\'évènement',
            message: 'Êtes-vous sûr de vouloir supprimer l\'évènement :TITLE',
            popup: 'Évènement supprimé avec succès.',
            title: 'Supprimer un évènement'
        },
        noDelete: 'Non, ne pas supprimer',
        notice: {
            button: 'Oui, supprimer l\'annonce',
            message: 'Êtes-vous sûr de vouloir supprimer l\'annonce :TITLE',
            popup: 'Annonce supprimée avec succès.',
            title: 'Supprimer une annonce',
        },
        sub_category: {
            button: 'Oui, supprimer la sous-catégorie',
            message: 'Êtes-vous sûr de vouloir supprimer la sous-catégorie :TITLE',
            popup: 'Sous-catégorie supprimée avec succès.',
            title: 'Supprimer une sous-catégorie de ressources'
        }
    },
    edit: {
        action: {
            title: 'Modifier les actions et liens rapides'
        },
        actuality: {
            title: 'Modifier une actualité'
        },
        alert: {
            delete: 'Supprimer l\'alerte',
            title: 'Modifier l\'alerte'
        },
        category: {
            title: 'Modifier une catégorie de ressources'
        },
        document: {
            title: 'Modifier une ressource'
        },
        employee: {
            delete: 'Supprimer l\'employé',
            title: 'Ajouter ou modifier un anniversaire'
        },
        event: {
            title: 'Modifier un évènement'
        },
        notice: {
            title: 'Modifier une annonce'
        },
        sub_category: {
            title: 'Modifier une sous-catégorie de ressources'
        }
    },
    label: {
        actuality: {
            text: 'Texte de l\'actualité',
            theme: 'Thématique de l\'actualité',
            title: 'Titre de l\'actualité'
        },
        birthday_day: 'Anniversaire de naissance',
        birthday_month: '',
        category: {
            base: 'Catégorie',
            title: 'Titre de la catégorie'
        },
        cover_image: 'Photo de couverture',
        date: 'Date',
        deleteReason: 'Raison',
        description: 'Description',
        document: {
            title: 'Titre du document',
            type: 'Type de ressource'
        },
        emplacement: 'Emplacement',
        employee: {
            name: 'Nom de l\'employé',
            start_date: 'Date d\'entrée en fonction',
        },
        end_date: 'Jour de fin',
        event: {
            description: 'Description de l\'évènement',
            title: 'Titre de l\'évènement'
        },
        file: 'Fichier',
        file_url: {
            file: 'Fichier à télécharger/consulter',
            url: 'Lien vers la ressource'
        },
        icon: 'Icône',
        images: 'Ajouter un ou des médias',
        location: 'Lieu',
        notice: {
            text: 'Texte de l\'annonce',
            title: 'Titre de l\'annonce'
        },
        save: 'Enregistrer',
        select_file_multiple: 'Choisir un ou des fichiers',
        select_file_single: 'Choisir un fichier',
        startDate: 'Jour de début',
        sub_category: {
            title: 'Titre de la sous-catégorie'
        },
        text: 'Texte',
        title: 'Titre',
        url: 'URL',
        ofEvent: 'de l\'évènement'
    },
    messages: {
        actuality: {
            images: 'L\'ensemble des documents joints ne peut dépasser 5 Mo. Maximum 6 médias par publication.'
        },
        category: {
            choose: 'Choisissez parmi les catégories existantes ou créez-en une nouvelle.'
        },
        irreversible: 'Cette opération est irréversible.',
        notice: {
            images: 'L\'ensemble des documents joints ne peut dépasser 5 Mo. Maximum 6 médias par annonce.'
        },
        reason: 'L’auteur de l’annonce pourra voir cette information.',
        repeater_links: 'Minimum 1 action et maximum 5 actions.',
        required: '* indique un champ obligatoire.',
        url: 'L\'URL devrait inclure le protocole (http://, https://, ...).',
        '500_ko_png_svg': 'Ne peut dépasser 500 Ko. Ne sont acceptés que les formats .png et .svg.',
        '500_ko_3_1_ratio': 'Ne peut dépasser 500 Ko. Un ratio de 3:1 est recommandé.',
        '5mb_pdf': 'Ne peut dépasser 5 Mo. Un format PDF est recommandé.',
		png_jpg: 'Ne sont acceptés que les formats .png, .jpg et .jpeg.'
    },
    placeholder: {
        day: 'jj',
        category_id: 'Sélectionner un emplacement',
        sub_category: 'Sélectionner un type',
        category: 'Sélectionner une catégorie',
        month: 'mm',
        birthday: 'Sélectionner une journée',
        birth_month: 'Sélectionner un mois',
        name: 'Sélectionner un employé ou en ajouter un nouveau',
        year: 'aaaa',
        parent_id: 'Sélectionner une catégorie',
        type: 'Sélectionner un type de ressource',
        deleteReason: 'Sélectionnez une raison'
    },
    errors: {
        birthday: 'Veuillez sélectionner une journée',
        birth_month: 'Veuillez sélectionner un mois',
        category_id: 'Veuillez choisir un emplacement',
				code0: 'Le code saisi est invalide. Veuillez réessayer.',
        cover_image: 'Veuillez choisir une image',
        date: 'Veuillez entrer une date écrite',
        deleteReason: 'Veuillez sélectionnez une raison',
        description: 'Veuillez entrer une description valide',
        employee_name: 'Veuillez sélectionner un employé ou en ajouter un nouveau',
        end_date: 'Veuillez entrer une date de fin valide',
        file: 'Veuillez choisir un fichier valide',
        icon: 'Veuillez choisir un fichier valide',
        icon0: 'Veuillez choisir un fichier valide',
        icon1: 'Veuillez choisir un fichier valide',
        icon2: 'Veuillez choisir un fichier valide',
        icon3: 'Veuillez choisir un fichier valide',
        icon4: 'Veuillez choisir un fichier valide',
        image: 'Veuillez choisir un fichier valide',
        images: 'Veuillez choisir maximum 6 médias qui ne dépassent pas 5 Mo total.',
        location: 'Veuillez entrer un lieu valide',
        loginEmail: 'Veuillez entrer une adresse courriel ayant un domaine odq.qc.ca ou farpodq.org',
        parent_id: 'Veuillez choisir une catégorie',
        url: 'Veuillez entrer un URL valide',
        start_date: 'Veuillez entrer une date d\'entrée valide',
				start_date_employee: 'Veuillez entrer une date d\'entrée valide',
				text: 'Veuillez entrer un texte valide',
        theme: 'Veuillez entrer un thème valide',
        title: 'Veuillez entrer un titre valide',
        type: 'Veuillez choisir un type valide'
    },
    reasons: {
        objective: 'L’annonce a atteint son objectif',
        rules: 'L’annonce ne respecte pas les règles de la communauté du babillard',
        old: 'L’annonce est expirée ou n’est plus d’actualité',
        pertinence: 'L’annonce est non pertinente ou hors sujet',
        false: 'L’annonce contient des informations incorrectes ou trompeuses',
        double: 'Cette annonce est un doublon',
        inapropriate: 'Le contenu est inapproprié ou offensant'
    }
}